module.exports = __webpack_public_path__ + "assets/img/perso2.d8cdfd7d.png";